type ContactPhoneLinkProps = {
  value?: string | null;
};

export function ContactPhoneLink({ value }: ContactPhoneLinkProps) {
  if (!value) {
    return <span>-</span>;
  }

  return (
    <a href={`tel:${value}`} className="underline underline-offset-4 hover:text-foreground">
      {value}
    </a>
  );
}
